<template>
  <div class="izdelkiBox">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'IzdelkiBox'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Izdelki/IzdelkiBox.vue